import(/* webpackMode: "eager" */ "/codebuild/output/src102202356/src/sirge-business-fe-next/src/app/error.tsx");
